import { render } from "./JHTransactionRecordHistoryTab.vue?vue&type=template&id=65639642&scoped=true"
import script from "./JHTransactionRecordHistoryTab.vue?vue&type=script&lang=ts"
export * from "./JHTransactionRecordHistoryTab.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-65639642"

export default script